// extracted by mini-css-extract-plugin
export default {"splitLayout":"SplitPageLayout_splitLayout__8aeI7","leftPanel":"SplitPageLayout_leftPanel__-5NqF","rightPanel":"SplitPageLayout_rightPanel__lPVJH"};